import { defineMessages } from "@/i18n";
import en from "./en";

export const onboardingMessages = defineMessages("onboarding", en);
